import PageToolbar from '@/components/linear/page-toolbar';
import { companiesPath } from '@/lib/linear-paths';
import CompanyForm from '@/pages/companies/components/company-form';
import type { Company } from '@/types/company';

interface Props {
  company: Pick<
    Company,
    'name' | 'isDefault' | 'githubOrgsText' | 'githubAccountsText' | 'githubRepoProjectMapText'
  > & { id: string | null };
}

export default function New({ company }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title="New workspace" showNew={false} />
      <div className="ln-page-scroll">
        <div className="ln-form-page">
          <h1>New workspace</h1>
          <p className="ln-lede">Add a company workspace to your portfolio.</p>
          <CompanyForm
            company={company}
            action={companiesPath()}
            method="post"
            submitLabel="Create workspace"
          />
        </div>
      </div>
    </div>
  );
}
